module.exports = __webpack_public_path__ + "static/media/Cup_medium.f41ebfae.png";